import { Outlet } from 'react-router-dom';

import './cabinet.scss';

export function CabinetLayout() {
	return (
		<div className="cabinet">
			<main className="main">
				<Outlet />
			</main>
		</div>
	);
}
